import { render, staticRenderFns } from "./AsiBtn.vue?vue&type=template&id=580182c6&scoped=true"
import script from "./AsiBtn.vue?vue&type=script&lang=ts"
export * from "./AsiBtn.vue?vue&type=script&lang=ts"
import style0 from "./AsiBtn.vue?vue&type=style&index=0&id=580182c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580182c6",
  null
  
)

export default component.exports